import { BiteLogGloryEvent } from './bite_log_glory_event.js';

export function name(event: BiteLogGloryEvent): string {
  switch (event) {
    case BiteLogGloryEvent.OpenRequestSuccess:
      return 'open-request-success';
    case BiteLogGloryEvent.OpenRequestError:
      return 'open-request-error';
    case BiteLogGloryEvent.OccupancyRequestSuccess:
      return 'occupancy-request-success';
    case BiteLogGloryEvent.OccupancyRequestError:
      return 'occupancy-request-error';
    case BiteLogGloryEvent.RegisterEventRequestSuccess:
      return 'register-event-request-success';
    case BiteLogGloryEvent.RegisterEventRequestError:
      return 'register-event-request-error';
    case BiteLogGloryEvent.AdjustTimeRequestSuccess:
      return 'adjust-time-request-success';
    case BiteLogGloryEvent.AdjustTimeRequestError:
      return 'adjust-time-request-error';
    case BiteLogGloryEvent.GetStatusRequestSuccess:
      return 'get-status-request-success';
    case BiteLogGloryEvent.GetStatusRequestError:
      return 'get-status-request-error';
    case BiteLogGloryEvent.InventoryRequestSuccess:
      return 'inventory-request-success';
    case BiteLogGloryEvent.InventoryRequestError:
      return 'inventory-request-error';
    case BiteLogGloryEvent.CloseRequestSuccess:
      return 'close-request-success';
    case BiteLogGloryEvent.CloseRequestError:
      return 'close-request-error';
    case BiteLogGloryEvent.SaleTransactionSuccess:
      return 'sale-transaction-success';
    case BiteLogGloryEvent.SaleTransactionError:
      return 'sale-transaction-error';
    case BiteLogGloryEvent.ChangeCancelRequestSuccess:
      return 'change-cancel-request-success';
    case BiteLogGloryEvent.ChangeCancelRequestError:
      return 'change-cancel-request-error';
    case BiteLogGloryEvent.UpdateManualDepositRequestSuccess:
      return 'update-manual-deposit-request-success';
    case BiteLogGloryEvent.UpdateManualDepositRequestError:
      return 'update-manual-deposit-request-error';
    case BiteLogGloryEvent.StatusChangeEvent:
      return 'status-change-event';
    case BiteLogGloryEvent.OpenSequenceSuccess:
      return 'open-sequence-success';
    case BiteLogGloryEvent.OpenSequenceError:
      return 'open-sequence-error';
    case BiteLogGloryEvent.ChangeResponseEvent:
      return 'change-response-event';
    case BiteLogGloryEvent.TransactionInterrupted:
      return 'transaction-interrupted';
    case BiteLogGloryEvent.EventSubscriptionError:
      return 'event-subscription-error';
    case BiteLogGloryEvent.KioskCashMachineStateChanged:
      return 'kiosk-cash-machine-state-changed';
    case BiteLogGloryEvent.InventoryEventSuccess:
      return 'inventory-event-success';
    case BiteLogGloryEvent.InventoryEventError:
      return 'inventory-event-error';
    case BiteLogGloryEvent.ParseError:
      return 'parse-error';
    case BiteLogGloryEvent.CancelPaymentCashOutNotMatchCashIn:
      return 'cancel-payment-cash-out-not-match-cash-in';
    case BiteLogGloryEvent.TransactionCancelled:
      return 'transaction-cancelled';
    case BiteLogGloryEvent.TransactionCancellationError:
      return 'transaction-cancellation-error';
  }
}
